module.exports = "/_next/static/images/OgWhatsApp-b20237dc301aca6421f36cbd78f9f8c0.png";